import ComponentLayout from "../../../../src/layouts/component-layout";
import { HeadingTags } from '@primer/react-brand';
import { Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  HeadingTags,
  Label,
  PropTableValues,
  React
};